import {Action} from "@ngrx/store";

export const LOAD_ECOMMERCE_TAX_CLASSES: string = '[ecommerce Tax Classes] Load Ecommerce Tax Classes';
export const LOAD_ECOMMERCE_TAX_CLASSES_SUCCESS: string = '[ecommerce Tax Classes] Load Ecommerce Tax Classes Success';
export const LOAD_ECOMMERCE_TAX_CLASSES_FAIL: string = '[ecommerce Tax Classes] Load Ecommerce Tax Classes Fail';

export class LoadEcommerceTaxClasses implements Action {
  readonly type: string = LOAD_ECOMMERCE_TAX_CLASSES;

  constructor(public payload: { websiteId: number }) {
  }
}

export class LoadEcommerceTaxClassesSuccess implements Action {

  readonly type: string = LOAD_ECOMMERCE_TAX_CLASSES_SUCCESS;

  constructor(public payload: {
    data: any,
    filterData: any,
    loaded?: boolean,
    loading?: boolean,
    websiteId: number
  }) {
  }

}

export class LoadEcommerceTaxClassesFail implements Action {

  readonly type: string = LOAD_ECOMMERCE_TAX_CLASSES_FAIL;

  constructor(public payload: any) {
  }

}

export type EcommerceTaxClassesAction = LoadEcommerceTaxClasses | LoadEcommerceTaxClassesSuccess | LoadEcommerceTaxClassesFail;
